import { createSlice } from '@reduxjs/toolkit';
import { AppsTypeProps } from './types';

export const initialState: AppsTypeProps = {
  applications: [],
  error: false,
  fetching: false,
};

export const appSlice = createSlice({
  name: 'apps',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getAppsRequest(state, action) {
      state.fetching = true;
      state.error = false;
    },
    getAppsSuccess(state, action) {
      state.fetching = false;
      state.applications = action.payload.data;
    },
    getAppsError(state, action) {
      state.fetching = false;
      state.error = action.payload;
    },
  },
  extraReducers: {},
});

export const { actions } = appSlice;

export default appSlice.reducer;
